export default {
  img: {
    width: '40px',
    display: 'block'
  },
  td: {
    padding: '5px'
  },
  placeholder: {
    lineHeight: '40px',
    color: '#2b95d6',
    fontStyle: 'italic'
  },
  a: {
    color: '#2a5db0',
    textDecoration: 'underline'
  }
};
